module.exports = __webpack_public_path__ + "static/media/folder-open.06e6a5aa.svg";